/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";
import React, { useEffect, useState, useRef } from "react";

// Array of image URLs

const bubbleAnimation = (duration, startX, randomSize) => keyframes`
  0% {
    transform: translate(${startX}px, ${randomSize}vh);
    //  opacity: 0;
  }
  10% {
    // opacity: 1;
  }
  90% {
    // opacity: 1;
  }
  100% {
    transform: translate(${startX}px, -110vh);
    //  opacity: 0;
  }
`;

const bubbleStyle = (duration, startX, imageUrl, randomSize) => css`
  position: absolute;
  bottom: -50px;
  width: 50px;
  height: 50px;
  background-size: cover;
  background-image: url(${imageUrl});
  border-radius: 50%;
  animation: ${bubbleAnimation(duration, startX, randomSize)} ${duration}s
    linear infinite;
`;

const Bubble = ({ imageUrl, index }) => {
  const [duration, setDuration] = useState(0);
  const [startX, setStartX] = useState(0);
  const [randomSize, setrandomSize] = useState(0);
  const bubbleRef = useRef(null);

  useEffect(() => {
    const randomDuration = Math.random() * 5 + 13; // Random duration between 5 and 10 seconds
    const randomStartX = Math.random() * window.innerWidth; // Random start position
    setDuration(randomDuration);
    setStartX(randomStartX);
    const randomSize = Math.floor(Math.random() * 50) + 1;
    setrandomSize(randomSize);
    if (bubbleRef.current) {
      bubbleRef.current.addEventListener("animationiteration", () => {
        setStartX(Math.random() * window.innerWidth);
      });
    }
  }, [index]);
  return (
    <div
      css={bubbleStyle(duration, startX, imageUrl, randomSize)}
      ref={bubbleRef}
    />
  );
};
const bubbleAnimation1 = (duration, startX, randomSize) => keyframes`
  0% {
    transform: translate(${startX}px, ${randomSize}vh);
    //  opacity: 0;
  }
  10% {
    // opacity: 1;
  }
  90% {
    // opacity: 1;
  }
  100% {
    transform: translate(${startX}px, -110vh);
    //  opacity: 0;
  }
`;

const bubbleStyle1 = (duration, startX, imageUrl, randomSize) => css`
  position: absolute;
  bottom: -50px;
  width: 50px;
  height: 50px;
  background-size: cover;
  background-image: url(${imageUrl});
  border-radius: 50%;
  animation: ${bubbleAnimation1(duration, startX, randomSize)} ${duration}s
    linear infinite;
`;

const Bubble1 = ({ imageUrl, index }) => {
  const [duration, setDuration] = useState(0);
  const [startX, setStartX] = useState(0);
  const [randomSize, setrandomSize] = useState(0);
  const bubbleRef = useRef(null);

  useEffect(() => {
    const randomDuration = Math.random() * 5 + 11; // Random duration between 5 and 10 seconds
    const randomStartX = Math.random() * window.innerWidth; // Random start position
    const randomSize = Math.floor(Math.random() * 100) + 1;
    setDuration(randomDuration);
    setStartX(randomStartX);
    setrandomSize(randomSize);
    if (bubbleRef.current) {
      bubbleRef.current.addEventListener("animationiteration", () => {
        setStartX(Math.random() * window.innerWidth);
      });
    }
  }, [index]);
  return (
    <div
      css={bubbleStyle1(duration, startX, imageUrl, randomSize)}
      ref={bubbleRef}
    />
  );
};

function AnimatedImages({ numberOfTimes = 1, opt = false }) {
  return (
    <div
      style={{
        backgroundImage: `url("/pics/login/login_background.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        height: "100vh",
        display: "flex",
        position: "fixed",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        css={css`
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;s  
        `}
      >
        {[...Array(numberOfTimes)].map((_, i) => (
          <React.Fragment key={i}>
            {[...Array(5)].map((_, j) => (
              <Bubble
                key={`bubble-${i}-${j}`}
                imageUrl={`/pics/login/pic_${j + 1}.jpg`}
                index={j}
              />
            ))}
            {true &&
              [...Array(10)].map((_, k) => (
                <Bubble1
                  key={`bubble1-${i}-${k + 5}`}
                  imageUrl={`/pics/login/pic_${k + 5 + 1}.jpg`}
                  index={k + 5}
                />
              ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default AnimatedImages;
